export class GetParam{
    constructor(getQuery) {
        this.dontype = null;
        this.period = null;
        this.background = null;

        this.qs = getQuery.substr(1);
        this.params = {};
        this.parseQuerstring();
    }

    parseQuerstring() {
        try{
            this.qs.split('&').reduce((a, b) => {
                let [key, val] = b.split('=');
                switch(key){
                    case 'dontype' :            // 재정의 불가
                    case 'period' : break;      // 재정의 불가
                    case 'background' : break;  // 재정의 불가
                    default : a[key] = ((val)? val : ''); break;
                }
                return a;
              }, this.params);
        }catch(e){
            console.error("파라미터가 잘못 되었습니다.");
            console.error(e);
        } 
     }

    setDefaultParam(dontype, period, background){
        this.dontype = dontype;
        this.period = period;
        this.background = background;
    }

    // GA충돌로 인한 utm -> box로 치환
    getQueryString(){
        try{
            let getQueryString = `?dontype=${encodeURIComponent(this.dontype)}&period=${encodeURIComponent(this.period)}`;
        
            if(this.background)
                getQueryString += `&background=${encodeURIComponent(this.background)}`;

            if(this.params)
            {
                for (const [key, value] of Object.entries(this.params)) {
                    // 파라미터 확장성을 위해서 utm_은 모두 box_로 치환한다. 
                    getQueryString += `&${key.replace(/utm_/g,"box_")}=${encodeURIComponent(value)}`;
                }     
            }

            return getQueryString;
        }catch(e){
            console.error("getQueryString() 실행중 오류 발생");
            console.error(e);
        }  
    }
}


// WEBPACK FOOTER //
// ./src/lib/payParam.js